const NAME = "ISSUE_ABSENCES";

export default NAME;
